(ns ui.animation-editor.templates
  "The presets of the story templates: the symbols of the CreateJS
   composition in `public/story-template/templates.js` (exported by
   Adobe Animate) that animate one layer each, with their icons, and the
   fonts the texts can use. Same data as
   `storrito.instagram.story.animation.templates`, which the recorder
   page uses to record the video; here with absolute icon paths, since
   the page lives under /ui/.")

(def presets
  {:headline [{:symbol-name "Headline_Static"
               :display-name "Static"
               :icon "/story-template/icons/static.svg"}
              {:symbol-name "Headline_Fade_In"
               :display-name "Fade In"
               :icon "/story-template/icons/fade-in.svg"}
              {:symbol-name "Headline_Top_In"
               :display-name "Top In"
               :icon "/story-template/icons/top-in.svg"
               ;; disabled, since Animate put it into the wrong layer
               :disabled true}
              {:symbol-name "Headline_Bild"
               :display-name "Fast Top In"
               :icon "/story-template/icons/top-in.svg"}
              {:symbol-name "Headline_Left_In_Right_Out"
               :display-name "Left in right out"
               :icon "/story-template/icons/left-in-right-out.svg"}]
   :background [{:symbol-name "Background_Static"
                 :display-name "Static"
                 :icon "/story-template/icons/static.svg"}
                {:symbol-name "Background_Zoom_In"
                 :display-name "Zoom In"
                 :icon "/story-template/icons/zoom-in.svg"}
                {:symbol-name "Background_Zoom_Out"
                 :display-name "Zoom Out"
                 :icon "/story-template/icons/zoom-out.svg"}
                {:symbol-name "Background_Left_In"
                 :display-name "Left In"
                 :icon "/story-template/icons/left-in.svg"}
                {:symbol-name "Background_Right_In"
                 :display-name "Right In"
                 :icon "/story-template/icons/right-in.svg"}
                {:symbol-name "Background_Top_In"
                 :display-name "Top In"
                 :icon "/story-template/icons/top-in.svg"}
                {:symbol-name "Background_Bottom_In"
                 :display-name "Bottom In"
                 :icon "/story-template/icons/bottom-in.svg"}
                {:symbol-name "Background_Fade_In_Background"
                 :display-name "Fade in from background"
                 :icon "/story-template/icons/fade-in.svg"}]
   :swipe [{:symbol-name "Swipe_Static"
            :display-name "Static"
            :icon "/story-template/icons/static.svg"}
           {:symbol-name "Swipe_Fade_In_Out"
            :display-name "Fade In Out"
            :icon "/story-template/icons/fade-in-out.svg"}
           {:symbol-name "Swipe_Bounce"
            :display-name "Bounce"
            :icon "/story-template/icons/bounce-up-down.svg"}]
   :teaser [{:symbol-name "Teaser_Static"
             :display-name "Static"
             :icon "/story-template/icons/static.svg"}
            {:symbol-name "Teaser_Bild"
             :display-name "Fast Bottom In"
             :icon "/story-template/icons/bottom-in.svg"
             ;; disabled, since Animate put it into the wrong layer
             :disabled true}
            {:symbol-name "Teaser_Left_In_Right_Out"
             :display-name "Left in right out"
             :icon "/story-template/icons/left-in-right-out.svg"}]})

(defn available
  "The presets of the `layer` the user can choose from."
  [layer]
  (remove :disabled
          (get presets layer)))

(def symbol-names
  "All symbols of the composition, also the disabled ones: every symbol
   is hidden before the chosen ones are shown."
  (mapv :symbol-name
        (mapcat val presets)))

(def fonts
  "The font families of the texts, loaded by the template page from
   Google Fonts (plus the system fonts Arial, Courier New and Times New
   Roman)."
  ["Abril Fatface"
   "Acme"
   "Alegreya"
   "Alegreya Sans"
   "Amatic SC"
   "Anton"
   "Archivo Black"
   "Arial"
   "Arvo"
   "Cinzel"
   "Courier New"
   "Dancing Script"
   "Fjalla One"
   "Francois One"
   "Gloria Hallelujah"
   "Inconsolata"
   "Indie Flower"
   "Josefin Slab"
   "Lobster"
   "Lobster Two"
   "Old Standard TT"
   "Oleo Script"
   "Open Sans Condensed"
   "Orbitron"
   "Pacifico"
   "Permanent Marker"
   "Poiret One"
   "Raleway"
   "Roboto"
   "Times New Roman"
   "Ubuntu"
   "Yanone Kaffeesatz"])
